// extracted by mini-css-extract-plugin
export default {"activity_card":"recommendations_activity_card__+4QAR"};